<div style="width:100%; height: 100%;    overflow: auto;" [ngStyle]="{'background-color': colorHome}">
    <div class="container" style="color: rgba(0, 0, 0, 0.8); padding: 0px;" *ngIf="!common.isLoadingApp">
        <div class="row">
            <h1 class="col-sm-7 dashboard"> Tableau de bord |
                <app-autocomplete [placeholder]="''" (selectfunction)="changeSite($event)"
                    [ngClass]="{'disabledbutton': !listeSite || (listeSite && listeSite.length === 1)}"
                    [results]="listeSite" [highlight]="true" [label]="''" [dropdownclass]="'mindropdown'"
                    [isCombo]="true" id="choixSiteHome" [defaultselected]="site" [htmlCode]="textSite"
                    [isFixedHTML]="true" style="position: absolute; width: calc(100% - 270px); top: 2px;">
                </app-autocomplete>
            </h1>
            <h4 class="col-sm-5 titleRight text-right"> Heureux de vous retrouver <span class="tooloc">
                    {{ common.userDetail.prenom || '' }} {{ common.userDetail.nom || '' }} </span></h4>
        </div>

        <!-- <div class="row">
            <div class="card bons-fact" [routerLink]="['/ecocontrat/contrat']" *ngIf="env.moduleEcocontrat && common.isContratFact">
                <div class="col-sm-12 text-center bons" style="height:100%;">
                    <h3>
                        Contrat
                        | <strong> Contrat en cours</strong>
                    </h3>
                    <h1 style="color: #376194; height: 54%; padding: 10%;"> {{data.NBR_CONTRAT || 0 }} </h1>
                </div>
            </div>
            <div class="card bons-fact" [routerLink]="['/ecocrm/planning']" *ngIf="env.moduleEcocrm && common.isEcocrm">
                <div class="col-sm-12 text-center bons" style="height:100%;">
                    <h3> RDV | <strong> Aujourd'hui </strong></h3>
                    <h1 style="color: #376194; height: 54%; padding: 10%;"> {{data.NBR_RDV_AUJOURDHUI || 0 }} </h1>
                    <div class="row text-center uppercase">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-4">
                                <div class="title">Total</div>
                                <h4 class="col-sm-12" style="color:#2d6a9c">
                                    {{data.NBR_RDV_SUP_AUJOURDHUI || 0 }} </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title"> Demain </div>
                                <h4 class="col-sm-12" style="color:#000000"> {{data.NBR_RDV_DEMAIN || 0 }}
                                </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title"> Mois </div>
                                <h4 class="col-sm-12" style="color:#000000"> {{data.NBR_RDV_MOIS_A_VENIR || 0 }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bons-fact" [routerLink]="['/ecocrm/gestion_devis']" *ngIf="env.moduleEcocrm && common.isEcocrm">
                <div class="col-sm-12 text-center bons" style="height:100%;">
                    <h3>Devis | <strong> Devis en cours</strong></h3>
                    <h1 style="color: #376194; height: 54%; padding: 10%;"> {{data.NBR_DEVIS_EN_COURS || 0 }} </h1>
                    <div class="row text-center uppercase">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-6">
                                <div class="title"> Dépassés </div>
                                <h4 class="col-sm-12" style="color:#2d6a9c">
                                    {{data.NBR_DEVIS_NONVALID_NONACCEPT_DATEFINPASSEE || 0 }} </h4>
                            </div>
                            <div class="col-sm-6">
                                <div class="title"> Client </div>
                                <h4 class="col-sm-12" style="color:#000000"> {{data.NBR_CLIENT_NONVALID_NONACCEPT || 0
                                    }} </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bons-fact" [routerLink]="['/ecocrm/relance_devis']" *ngIf="env.moduleEcocrm && common.isEcocrm">
                <div class="col-sm-12 text-center bons" style="height:100%;">
                    <h3>Relance | <strong> Devis à relancer</strong></h3>
                    <h1 style="color: #376194; height: 54%; padding: 10%;"> {{data.NBR_TOTAL_DEVIS_RELANCE || 0 }} </h1>
                    <div class="row text-center uppercase">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-4">
                                <div class="title"> Niveau 1 </div>
                                <h4 class="col-sm-12" style="color:#080808">
                                    {{data.NBR_DEVIS_RELANCE1 || 0 }} </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title"> Niveau 2 </div>
                                <h4 class="col-sm-12" style="color:#f69c1b"> {{data.NBR_DEVIS_RELANCE2 || 0 }}
                                </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title"> Niveau 3 </div>
                                <h4 class="col-sm-12" style="color:red"> {{data.NBR_DEVIS_RELANCE3 || 0 }} </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card planning" [routerLink]="['ecoloc/planning']" *ngIf="env.moduleEcoloc && common.isEcoloc">
                <div class="col-sm-12 text-center">
                    <h3>Planning | <strong>{{moment | date: 'dd.MM.yyyy'}}</strong></h3>

                    <div class="col-sm-6">
                        <div class="circle">
                            <img src="assets/images/icons/absent.svg" alt="absent" />
                            <h4>{{data.TOTAL_INDISPO_CHAUFFEUR || 0}}</h4>
                        </div>
                        <span>ABSENTS</span>
                    </div>
                    <div class="col-sm-6">
                        <div class="circle" style="background:rgb(248, 163, 52)">
                            <img src="assets/images/icons/indisponibles.svg" alt="indisponibles" />
                            <h4>{{data.TOTAL_INDISPO_CAMION || 0}}</h4>
                        </div>
                        <span>INDISPONIBLES</span>
                    </div>
                </div>
            </div>
            <div class="card retour-bons" [routerLink]="['ecoloc/validation']" *ngIf="env.moduleEcoloc && common.isEcoloc">
                <div class="col-sm-12 text-center" style="background-color: #376194;color: #fff;height: 58%;">
                    <h3> Validation | <strong> En attente de validation </strong></h3>
                    <h1> {{totalRetourbon()}} </h1>
                </div>
                <div class="col-sm-12" style="padding:5px 0px;">
                    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                        [colors]="color" [legend]="barChartLegend" [chartType]="barChartType" (chartHover)="chartHovered($event)"
                        (chartClick)="chartClicked($event)"></canvas>
                </div>
            </div>
            <div class="card bons-fact" [routerLink]="['/ecofact/gestion_bons']" *ngIf="env.moduleEcofact && common.isEcofact">
                <div class="col-sm-12 text-center bons">
                    <h3>Bons | <strong>En attente de facturation</strong></h3>

                    <h1 style="color: #376194; margin-bottom: 23px;"> {{data.TOTAL_BON_A_FACTURER || 0 }} </h1>
                    <div class="row text-center uppercase">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-4">
                                <div class="title">Contient matière</div>
                                <h4 class="col-sm-12" style="color:#000000">
                                    {{data.TOTAL_BON_A_FACTURER_CONTENANT_MATIERE || 0 }} </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title">Modifiés</div>
                                <h4 class="col-sm-12" style="color:#2d6a9c"> {{data.TOTAL_BON_A_FACTURER_MANUEL || 0 }}
                                </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title">Ne pas facturer</div>
                                <h4 class="col-sm-12" style="color:#f7a62a"> {{data.TOTAL_BON_A_FACTURER_NEPAS_FACTURER
                                    || 0 }} </h4>
                            </div>
                        </div>
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-4 afacturer">
                                <div class="title">à facturer</div>
                                <h4 class="col-sm-12"> {{data.TOTAL_BON_A_FACTURER_PRET_A_FACTURER || 0 }} </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title">non contrôlés</div>
                                <h4 class="col-sm-12" style="color:#000000"> {{data.TOTAL_BON_A_FACTURER_NON_CONTROLES
                                    || 0 }} </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title">non conforme</div>
                                <h4 class="col-sm-12" style="color:#f96900"> {{data.TOTAL_BON_A_FACTURER_NON_CONFORMES
                                    || 0 }} </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bons-fact" [routerLink]="['/ecobennes/mvt_bennes']" *ngIf="env.moduleEcobennes && common.isEcobennes && !common.isPrestation">
                <div class="col-sm-12 text-center bons" style="height:100%;">
                    <h3> Contenants | <strong> Total </strong></h3>
                    <h1 style="color: #376194; height: 54%; padding: 10%;"> {{data.CONTENANT_TOTAL || 0 }} </h1>
                    <div class="row text-center uppercase">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-6">
                                <div class="title">Non programmés</div>
                                <h4 class="col-sm-12" style="color:#000000">
                                    {{data.CONTENANT_NON_PROG || 0 }} </h4>
                            </div>
                            <div class="col-sm-6">
                                <div class="title"> Programmés </div>
                                <h4 class="col-sm-12" style="color:#2d6a9c"> {{data.CONTENANT_PROG || 0 }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card bons-fact" [routerLink]="['/ecobennes/planning_contenant']" *ngIf="env.moduleEcobennes && common.isEcobennes  && !common.isPrestation">
                <div class="col-sm-12 text-center bons" style="height:100%;">
                    <h3>Planning Cont | <strong>Non assignés</strong></h3>
                    <h1 style="color: #376194; height: 54%; padding: 10%;"> {{data.PLANNING_NON_ASSIGN || 0 }} </h1>
                    <div class="row text-center uppercase">
                        <div class="col-sm-12" style="padding: 0;">
                            <div class="col-sm-4">
                                <div class="title"> Total </div>
                                <h4 class="col-sm-12" style="color:#2d6a9c">
                                    {{data.PLANNING_TOTAL || 0 }} </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title"> Demain </div>
                                <h4 class="col-sm-12" style="color:#000000"> {{data.PLANNING_DEMAIN || 0 }}
                                </h4>
                            </div>
                            <div class="col-sm-4">
                                <div class="title"> Semaine </div>
                                <h4 class="col-sm-12" style="color:#000000"> {{data.PLANNING_SEMAINE || 0 }} </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card retour-bons" [routerLink]="[common.isPrestation ? '/recylog/prestation' :'/ecobennes/retour_bons']"
                *ngIf="env.moduleEcobennes && common.isEcobennes">
                <div class="col-sm-12 text-center" style="background-color: #299c73;color: #fff;height: 58%;">
                    <h3> {{ common.isPrestation ? 'Prestations' : 'Retour des bons'}} | <strong> En attente de validation </strong></h3>
                    <h1> {{totalRetourbonEcobenne()}} </h1>
                </div>
                <div class="col-sm-12" style="padding:5px 0px;">
                    <canvas baseChart [datasets]="barChartDataEcobenne" [labels]="barChartLabelsEcobenne" [options]="barChartOptions"
                        [colors]="color" [legend]="barChartLegend" [chartType]="barChartType" (chartHover)="chartHovered($event)"
                        (chartClick)="chartClicked($event)"></canvas>
                </div>
            </div>
        </div> -->
        <div class="row">
            <ng-template ngFor let-tuile [ngForOf]="tuiles">
                <mat-grid-list *ngIf="tuile.droit" class="col-sm-12" [cols]="(tuile.nbrVisible == 2) ? 4 :tuile.nbrVisible" rowHeight="130px">
                    <ng-template ngFor let-tile [ngForOf]="tuile.tuiles">
                        <mat-grid-tile *ngIf="tile.droit" [colspan]="tile.col" rowspan="1" class="paddingGrid">
                            <mat-card class="matClass" *ngIf="!tile.withParam" [routerLink]="tile.route">
                                <div class="col-sm-12 titreTile" style="padding: 0px 8px;"
                                    [ngStyle]="{'background-color': backCouleur}">
                                    <label class="uppercase" *ngIf="common.isPrestation"><span
                                            [ngStyle]="{'color': colorLibelle}">{{ tile.libelleModule}}</span></label>
                                    <label class="uppercase" *ngIf="!common.isPrestation">Eco<span
                                            [ngStyle]="{'color': colorLibelle}">{{tuile.libelle}}</span></label>
                                </div>
                                <div class="col-sm-12 corpTuile uppercase" style="height: calc(100% - 21px);">
                                    <div class="col-sm-12" style="padding: 0px;" >
                                        <div class="col-sm-12 text-center" style="padding: 0px;" >
                                            <div class="col-sm-12">
                                                <app-icons-tuiles [icon]="tile.icon"></app-icons-tuiles>
                                            </div>
                                            <div class="col-sm-12 libelle" [ngStyle]="{'color': colorLibelle}">
                                                {{tile.libelle}}</div>
                                        </div>
                                        <!-- <div class="col-sm-12 col2" style="padding: 0px;" *ngSwitchCase="2">
                                            <ng-template [ngIf]="tile.libelle === 'contenants'">
                                                <div class="col-sm-6">
                                                    <div class="col-sm-12" style="line-height: 0;">
                                                        <app-icons-tuiles [icon]="tile.icon"></app-icons-tuiles>
                                                    </div>
                                                    <div class="col-sm-12 libelle" style="line-height: 2;"
                                                        [ngStyle]="{'color': colorLibelle}">
                                                        {{tile.libelle}}</div>
                                                </div>
                                                <div class="col-sm-6 text-center valeur" style="padding: 0"
                                                    [ngStyle]="{'color': colorValeur}"
                                                    [ngClass]="{'pull-left': tile.reverse}">
                                                    {{ tile.valuer ? getValue(tile.valuer) : 0 }}
                                                </div>
                                            </ng-template>
                                            <ng-template [ngIf]="tile.libelle !== 'contenants'">
                                                <div class="col-sm-5 libelle" [ngStyle]="{'color': colorLibelle}"
                                                    [ngClass]="{'pull-right': tile.reverse}">
                                                    {{tile.libelle}}
                                                </div>
                                                <div class="col-sm-3" style="padding: 13px 0 0;"
                                                    [ngClass]="{'pull-right': tile.reverse, 'stockBac': tile.icon === 'bac_stock'}">
                                                    <app-icons-tuiles [icon]="tile.icon"></app-icons-tuiles>
                                                </div>
                                                <div class="col-sm-4 text-center valeur" style="padding: 0"
                                                    [ngStyle]="{'color': colorValeur}"
                                                    [ngClass]="{'pull-left': tile.reverse}">
                                                    {{ tile.valuer ? getValue(tile.valuer) : 0 }}
                                                </div>
                                            </ng-template>
                                        </div> -->
                                    </div>
                                </div>
                            </mat-card>
                            <mat-card class="matClass" *ngIf="tile.withParam" (click)="clickADVContrat()" [routerLink]="tile.route">
                                <div class="col-sm-12 titreTile" style="padding: 0px 8px;"
                                    [ngStyle]="{'background-color': backCouleur}">
                                    <label class="uppercase" *ngIf="common.isPrestation"><span
                                            [ngStyle]="{'color': colorLibelle}">{{ tile.libelleModule}}</span></label>
                                    <label class="uppercase" *ngIf="!common.isPrestation">Eco<span
                                            [ngStyle]="{'color': colorLibelle}">{{tuile.libelle}}</span></label>
                                </div>
                                <div class="col-sm-12 corpTuile uppercase" style="height: calc(100% - 21px);">
                                    <div class="col-sm-12" style="padding: 0px;" >
                                        <div class="col-sm-12 text-center" style="padding: 0px;">
                                            <div class="col-sm-12">
                                                <app-icons-tuiles [icon]="tile.icon"></app-icons-tuiles>
                                            </div>
                                            <div class="col-sm-12 libelle" [ngStyle]="{'color': colorLibelle}">
                                                {{tile.libelle}}</div>
                                        </div>
                                        <!-- <div class="col-sm-12 col2" style="padding: 0px;" *ngSwitchCase="2">
                                            <ng-template [ngIf]="tile.libelle === 'contenants'">
                                                <div class="col-sm-6">
                                                    <div class="col-sm-12" style="line-height: 0;">
                                                        <app-icons-tuiles [icon]="tile.icon"></app-icons-tuiles>
                                                    </div>
                                                    <div class="col-sm-12 libelle" style="line-height: 2;"
                                                        [ngStyle]="{'color': colorLibelle}" >
                                                        {{tile.libelle}}</div>
                                                </div>
                                                <div class="col-sm-6 text-center valeur" style="padding: 0"
                                                    [ngStyle]="{'color': colorValeur}"
                                                    [ngClass]="{'pull-left': tile.reverse}">
                                                    {{ tile.valuer ? getValue(tile.valuer) : 0 }}
                                                </div>
                                            </ng-template>
                                            <ng-template [ngIf]="tile.libelle !== 'contenants'">
                                                <div class="col-sm-5 libelle" [ngStyle]="{'color': colorLibelle}"
                                                    [ngClass]="{'pull-right': tile.reverse}" style="    white-space: nowrap;">
                                                    {{tile.libelle}}
                                                </div>
                                                <div class="col-sm-3" style="padding: 13px 0 0;"
                                                    [ngClass]="{'pull-right': tile.reverse, 'stockBac': tile.icon === 'bac_stock'}">
                                                    <app-icons-tuiles [icon]="tile.icon"></app-icons-tuiles>
                                                </div>
                                                <div class="col-sm-4 text-center valeur" style="padding: 0"
                                                    [ngStyle]="{'color': colorValeur}"
                                                    [ngClass]="{'pull-left': tile.reverse}">
                                                    {{ tile.valuer ? getValue(tile.valuer) : 0 }}
                                                </div>
                                            </ng-template>
                                        </div> -->
                                    </div>
                                </div>
                            </mat-card>
                        </mat-grid-tile>
                    </ng-template>
                </mat-grid-list>
            </ng-template>
        </div>
    </div>
    <div *ngIf="common.isLoadingApp" class="loading">
        <div class="sk-fading-circle" style="margin: auto">
            <div class="sk-circle1 sk-circle"></div>
            <div class="sk-circle2 sk-circle"></div>
            <div class="sk-circle3 sk-circle"></div>
            <div class="sk-circle4 sk-circle"></div>
            <div class="sk-circle5 sk-circle"></div>
            <div class="sk-circle6 sk-circle"></div>
            <div class="sk-circle7 sk-circle"></div>
            <div class="sk-circle8 sk-circle"></div>
            <div class="sk-circle9 sk-circle"></div>
            <div class="sk-circle10 sk-circle"></div>
            <div class="sk-circle11 sk-circle"></div>
            <div class="sk-circle12 sk-circle"></div>
        </div>
        <div class="col-sm-12 text-center" style="padding: 15px;">
            Chargement des données de votre société ...
        </div>
    </div>
</div>

<ng-template #document>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12">
            <app-gestion-document [data]="common.listDoc" (hidefunction)="common.closeModal()"></app-gestion-document>
        </div>
    </div>
</ng-template>

<ng-template #msgCommon>
    <div class="modal-body" style="height: auto">
        <div class="col-sm-12" style="padding: 0;">
            <div class="col-sm-12" style="padding: 0;">
                <span class="cofirmemsg"> {{ common.errorMsg }} </span>
            </div>
        </div>
        <div class="text-right col-sm-12" style="margin-top: 15px;padding: 0;">
            <button type="button" class=" btn-close btn-validerMdl" (click)="common.errorMsg = ''; common.closeModal()"> Fermer
            </button>
        </div>
    </div>
</ng-template>